import { motion, useScroll, useTransform } from "framer-motion";
import { MistLayer } from "@/components/MistLayer";

export const PageBackdrop = ({ src, position = "object-right" }) => {
  const { scrollY } = useScroll();
  const y = useTransform(scrollY, [0, 800], [0, 90]);

  return (
    <div
      className="pointer-events-none absolute inset-x-0 top-0 h-[88vh] min-h-[560px] overflow-hidden"
      aria-hidden="true"
      data-testid="page-backdrop"
    >
      <motion.img
        src={src}
        alt=""
        style={{ y }}
        initial={{ opacity: 0, scale: 1.05 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 1.8, ease: [0.22, 1, 0.36, 1] }}
        className={`h-[110%] w-full object-cover ${position}`}
      />
      <MistLayer />
      <div className="absolute inset-0 bg-gradient-to-r from-paper via-paper/75 to-paper/0" />
      <div className="absolute inset-x-0 top-0 h-28 bg-gradient-to-b from-paper to-transparent" />
      <div className="absolute inset-x-0 bottom-0 h-2/3 bg-gradient-to-t from-paper via-paper/80 to-transparent" />
    </div>
  );
};
